import { createSlice } from '@reduxjs/toolkit';

const conversationStatisticsSlice = createSlice({
  name: 'conversationStatistics',
  initialState: {
    triggerRefresh: false,
  },
  reducers: {
    requestStatisticsRefresh: (state) => {
      state.triggerRefresh = true;
    },
    statisticsRefreshHandled: (state) => {
      state.triggerRefresh = false;
    },
  },
});

export const { requestStatisticsRefresh, statisticsRefreshHandled } = conversationStatisticsSlice.actions;

export default conversationStatisticsSlice.reducer;
